/**
 * planned_reps on a program slot is a free-form string ("8", "8-12", "AMRAP")
 * for human readability. When pre-filling a workout set we need a numeric
 * target — pull the first integer; for ranges that's the lower bound, which
 * is the conservative starting point a user can edit upward as they go.
 * Returns null for unparseable text so the input stays empty rather than
 * wrong (e.g. "AMRAP" → no pre-fill, user types the actual rep count).
 */
export function parsePlannedReps(planned: string | null): number | null {
  if (planned === null) return null;
  const match = /\d+/.exec(planned);
  if (!match) return null;
  const n = Number(match[0]);
  return Number.isFinite(n) && n > 0 ? n : null;
}
